const position = "top center"
const defaultDisplayTime = 5000

export default class Message {

  static info(message, displayTime) {

    if (!displayTime)
      displayTime = defaultDisplayTime

    $("body").toast({ message, position, displayTime, class: "black", showIcon: "info" })
  }

  static success(message, displayTime) {    

    if (!displayTime)
      displayTime = defaultDisplayTime

    $("body").toast({ message, position, displayTime, class: "success", showIcon: "check" })
  }  

  static warn(message, displayTime) {

    if (!displayTime)
      displayTime = defaultDisplayTime

    $("body").toast({ message, position, displayTime, class: "orange", showIcon: "exclamation" })
  }

  static error(message, title, displayTime) {

    if (!title)
      title = "Erro de execução"

    if (!displayTime)
      displayTime = defaultDisplayTime  

    $("body").toast({ 
      message, 
      title, 
      position, 
      class: "error",
      showProgress: "top",
      displayTime,
      className: {
        toast: "ui message",
      },
    })
  }
}
